import { FlightCardHighlightStyle } from "../components/elements/FlightCard/components/FlightCardHighlight.js";
import { FlightBadgeVariant } from "@flights/types";
const getFlightCardHighlightStyle = (bestOfferHighlight) => bestOfferHighlight?.style === "PRIMARY"
    ? FlightCardHighlightStyle.PRIMARY
    : bestOfferHighlight?.style === "GENIUS"
        ? FlightCardHighlightStyle.GENIUS
        : undefined;
const getFlightCardBadgeStyle = (campaignBadge) => campaignBadge.style === "GENIUS"
    ? FlightBadgeVariant.GENIUS
    : campaignBadge.style === "DARK"
        ? FlightBadgeVariant.NEUTRAL
        : campaignBadge.style === "VIVID"
            ? FlightBadgeVariant.CONSTRUCTIVE
            : FlightBadgeVariant.PRIMARY;
export const getCampaignBestOfferHighlightConfig = (bestOfferHighlight) => {
    const bestOfferHighlightStyle = getFlightCardHighlightStyle(bestOfferHighlight);
    const bestOfferHighlightText = bestOfferHighlight?.headerText;
    return { bestOfferHighlightStyle, bestOfferHighlightText };
};
export const getCampaignBadgesConfig = (campaignBadges) => {
    return (campaignBadges?.map((campaignBadge) => ({
        style: getFlightCardBadgeStyle(campaignBadge),
        text: campaignBadge.text,
        hover: campaignBadge.hover,
        ariaLabel: campaignBadge.ariaLabel ?? campaignBadge.text
    })) || []);
};
export const getCampaignBannerAsset = (campaignStyle) => {
    switch (campaignStyle) {
        case "GENIUS":
            return {
                setName: "illustrations-traveller",
                assetName: "GeniusFlightsBadge"
            };
        case "DARK":
            return {
                setName: "illustrations-traveller",
                assetName: "DiscountPercent"
            };
        case "VIVID":
            return {
                setName: "illustrations-traveller",
                assetName: "PromotionPercent"
            };
        default:
            return { setName: "illustrations-traveller", assetName: "TripsUnlockSpot" };
    }
};
